import React from 'react';

const withDropdown = Component => (
  class Dropdown extends React.Component {
    constructor(props) {
      super(props);

      this.state = { show: false };
      this.dropdown = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
      const { show } = this.state;

      if (show && !prevState.show) {
        this.toggleEventListeners('add');
      } else if (!show && prevState.show) {
        this.toggleEventListeners('remove');
      }
    }

    onClick = () => this.setState(prevState => ({
      show: !prevState.show,
    }))

    onDocumentEvent = (e) => {
      if (!this.dropdown.current.contains(e.target)) {
        this.close();
      }
    }

    onKeyDown = (e) => {
      if (e.keyCode === 27 || e.key === 'Escape') {
        this.close();
      }
    }

    toggleEventListeners = (toggle) => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        document[`${toggle}EventListener`]('click', this.onDocumentEvent);
        return;
      }

      document[`${toggle}EventListener`]('keydown', this.onKeyDown);
      document[`${toggle}EventListener`]('mousedown', this.onDocumentEvent);
      document[`${toggle}EventListener`]('focusin', this.onDocumentEvent);
    }

    close = () => this.setState({
      show: false,
    })

    render() {
      const { show } = this.state;

      return (
        <Component
          {...this.props}
          show={show}
          ref={this.dropdown}
          onClick={this.onClick}
        />
      );
    }
  }
);

export default withDropdown;
